import TileLayer from "ol/layer/Tile";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import WMTS from "ol/source/WMTS";
import {ImageWMS} from "ol/source";
import ImageLayer from "ol/layer/Image";

const projExtent = [274000, 3087000, 3327000, 7173000];
export const resolutions = [8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8/*, 1.4, 0.7, 0.28, 0.14, 0.07*/];
const matrixIds = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"/*, "12", "13", "14", "15", "16"*/];
const tileGrid = new WMTSTileGrid({
    // origin: getTopLeft(projExtent),
    extent: projExtent,
    resolutions,
    matrixIds
});

function env() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('env')) return params.get('env');

    const hostname = window.location.hostname;
    const testEnvs = ['localhost', 'test-', 'dev-'];
    if (testEnvs.some(env => hostname.indexOf(env) === 0)) {
        return 'test'
    } else if (hostname.indexOf('stage-') === 0) {
        return 'stage'
    } else {
        return 'prod'
    }
}

export function wmtsMapHost() {
    switch (env()) {
        case 'test':
            return 'test-portals-maps.landcareresearch.co.nz'
        case 'stage':
            return 'stage-portals-maps-{1-4}.landcareresearch.co.nz'
        default:
            return 'portals-maps-aws-{1-4}.landcareresearch.co.nz'
    }
}

export function wmsMapHost() {
    switch (env()) {
        case 'test':
            return 'test-portals-maps.landcareresearch.co.nz'
        case 'stage':
            return 'stage-portals-maps-2.landcareresearch.co.nz'
        default:
            return 'portals-maps-aws-3.landcareresearch.co.nz'
    }
}

export function wmtsLayer(options) {
    const {hdpi, mapLayersURL, layerName, attribution} = options;
    const matrixSet = hdpi ? "NZTM2000HDPI" : "NZTM2000";

    const source = new WMTS({
        tileGrid,
        crossOrigin: 'anonymous',
        projection: "EPSG:2193",
        url: mapLayersURL,
        format: 'jpeng',
        layer: layerName + (hdpi ? '-HDPI' : ''),
        style: 'default',
        tilePixelRatio: hdpi ? 2 : 1,
        matrixSet
    });

    return new TileLayer({ source })
}

export function mapUnitWMSLayer(options) {
    const {gisLayer, soilMapUnitCode, hdpi, url} =  options;

    const source = new ImageWMS({
        params: {
            SERVICE: 'WMS',
            VERSION: '1.1.1',
            FORMAT: 'image/png',
            TRANSPARENT: 'true',
            LAYERS: 'smap_smu',
            SRS: 'EPSG:2193',
            STYLES: '',
            gislayer: gisLayer,
            map: '/opt/mapserver/mapfiles/smap.map',
            soilmapuc: soilMapUnitCode
        },
        url: url || `https://${wmsMapHost()}/cgi-bin/mapserv`,
        crossOrigin: 'anonymous',
        hidpi: hdpi,
        serverType: 'mapserver'
    });

    return new ImageLayer({ source });
}